import { CupOffIcon } from './CupOffIcon';

/**
 * author: Austin Andrews
 * id FD336A31-52C0-41AF-A0F3-BA475DEA1A54
 * name cup-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cup-off.svg
 * tags
 * - Food / Drink 
 */
export const GlassOffIcon = CupOffIcon;
export default GlassOffIcon